// extracted by mini-css-extract-plugin
export default {"link":"ProtectedLink_link__sRvAv","disabled":"ProtectedLink_disabled__BPWJQ"};